/** API contracts shared by admin-api and admin-web. */
export const API_PREFIX = '/api/v1';
export const SERVICE_NAME = 'quds-central-admin';
/** Required on every state-changing request (CSRF defence, see PHASE_2_ARCHITECTURE.md). */
export const CSRF_HEADER = 'x-requested-with';
export const CSRF_HEADER_VALUE = 'quds-central-admin';
//# sourceMappingURL=api.js.map